import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="page-payment-cancel">
      <XCircle size={48} className="mx-auto brand-muted mb-6" />
      <h1 className="font-serif text-4xl brand-text mb-4">Pagamento cancelado</h1>
      <p className="brand-muted mb-8">A sua compra não foi concluída. Os produtos continuam no carrinho.</p>
      <div className="flex gap-3 justify-center">
        <Link to="/checkout" className="btn-primary">Tentar novamente</Link>
        <Link to="/loja" className="btn-ghost">Continuar a comprar</Link>
      </div>
    </main>
  );
}
